import { useState } from 'react';
import CustomTable from '@myComponents/CustomTable';
import { FEEDBACK_LIST } from '../../graphql/Query/users';
import { useQuery } from '@apollo/client';
import { columns } from './columns';
import moment from 'moment';
import FeedbackSidebar from './Sidebar';

const variables = {
  search: {
    dates: [moment().utc().subtract(30, 'days').toDate(), moment().utc().toDate()],
    q: '',
    perPage: 10,
    page: 1
  }
};

const FeedBackList = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedFeedback, setSelectedFeedback] = useState(null);

  const { data, refetch, loading } = useQuery(FEEDBACK_LIST, {
    variables
  });

  const toggleSidebar = (feedback = null) => {
    setSidebarOpen(!sidebarOpen);
    setSelectedFeedback(feedback);
  };

  return (
    <>
      <CustomTable
        loading={loading}
        store={data?.feedbackList?.docs || []}
        data={{ ...data?.feedbackList, docs: undefined }}
        refetch={refetch}
        filterOptions={{
          types: [
            {
              id: 'feedback_dates',
              name: 'dates',
              placeholder: 'Seleccionar Fecha',
              type: 'rangepicker'
            }
          ]
        }}
        variables={variables}
        columns={columns({ toggleSidebar })}
      />
      <FeedbackSidebar
        open={sidebarOpen}
        toggleSidebar={toggleSidebar}
        selectedFeedback={selectedFeedback}
      />
    </>
  );
};

export default FeedBackList;
